import React, { useState } from "react";
import {
  NotificationIcon,
  OrganizationIcon,
  PreferencesIcon,
  ProfileIcon,
} from "../../../../components/Icons";
import { useNavigate } from "react-router-dom";

const LeftSidebar = () => {
  const [selectedtab, setSelectedtab] = useState("profile");

  console.log("selectedtab", selectedtab);
const navigate=useNavigate()

  const GonavigatePage=()=>{
    setSelectedtab('notification')
    navigate('/notification')
  }

  return (
    <div className="mainLeftSidebar">
      <div className="mainDiv">
        <div className="mainheadding">Account</div>

        <div onClick={() => setSelectedtab("profile")}
          className={`mainsubheading ${
            selectedtab === "profile" ? "activetab" : ""
          }`}
        >
          <div className="iconclass">
            <ProfileIcon />
          </div>

          <div className={selectedtab === "profile" ? "activesubheading" : "subheading"}>Profile</div>
        </div>
        <div onClick={() => setSelectedtab("prefrence")}
          className={`mainsubheading ${
            selectedtab === "prefrence" ? "activetab" : ""
          }`}>
          <div className="iconclass">
            <PreferencesIcon />
          </div>

          <div className={selectedtab === "prefrence" ? "activesubheading" : "subheading"}>Preferences</div>
        </div>

        <div  onClick={GonavigatePage}   className={`mainsubheading ${
            selectedtab === "notification" ? "activetab" : ""
          }`}>
          <div className="iconclass">
            <NotificationIcon />
          </div>

          <div className={selectedtab === "notification" ? "activesubheading" : "subheading"}>Notifications</div>
        </div>
      </div>

      <div style={{ marginTop: "24px" }} className="mainDiv">
        <div className="mainheadding">Organization</div>

        <div onClick={() => setSelectedtab("general")}
          className={`mainsubheading ${
            selectedtab === "general" ? "activetab" : ""
          }`}>
          <div className="iconclass">
            <OrganizationIcon />
          </div>

          <div className={selectedtab === "general" ? "activesubheading" : "subheading"}>General</div>
        </div>
        <div className="mainsubheading">
          <div className="iconclass">
            <OrganizationIcon />
          </div>

          <div className="subheading">Application Information</div>
        </div>

        <div className="mainsubheading">
          <div className="iconclass">
            <OrganizationIcon />
          </div>

          <div className="subheading">Provider Details</div>
        </div>

        <div className="mainsubheading">
          <div className="iconclass">
            <OrganizationIcon />
          </div>

          <div className="subheading">Addresses</div>
        </div>

        <div className="mainsubheading">
          <div className="iconclass">
            <OrganizationIcon />
          </div>

          <div className="subheading">Key Personnel</div>
        </div>

        <div className="mainsubheading">
          <div className="iconclass">
            <OrganizationIcon />
          </div>

          <div className="subheading">Suitability Questions</div>
        </div>

        <div className="mainsubheading">
          <div className="iconclass">
            <OrganizationIcon />
          </div>

          <div className="subheading">Service Delivery Questions</div>
        </div>
        <div className="mainsubheading">
          <div className="iconclass">
            <OrganizationIcon />
          </div>

          <div className="subheading">Registration Groups</div>
        </div>
        <div className="mainsubheading">
          <div className="iconclass">
            <OrganizationIcon />
          </div>

          <div className="subheading">NDIS Practice Standard</div>
        </div>

        <div className="mainsubheading">
          <div className="iconclass">
            <OrganizationIcon />
          </div>

          <div className="subheading">Service Profile</div>
        </div>
        <div className="mainsubheading">
          <div className="iconclass">
            <OrganizationIcon />
          </div>

          <div className="subheading">Workers</div>
        </div>
        <div className="mainsubheading">
          <div className="iconclass">
            <OrganizationIcon />
          </div>

          <div className="subheading">Outlets</div>
        </div>
      </div>
    </div>
  );
};

export default LeftSidebar;
